import { Box, Button, CircularProgress } from '@mui/material';

const styles = {
    footer: {
        padding: '16px 16px',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        borderTop: '1px solid #E0E0E0!important',
        bgcolor: '#fff',
        borderRadius: '0px 0px 8px 8px',
        flexShrink: 0,
    },
    cancelBtn: {
        textTransform: 'uppercase',
        fontWeight: 500,
        // color: 'rgba(0, 0, 0, 0.87)',
        '&:hover': {
            // borderColor: 'rgba(0, 0, 0, 0.87)',
            // backgroundColor: 'rgba(0, 0, 0, 0.04)',
        },
    },
    back: {
        minWidth: 90,
        height: 40,
        fontWeight: 600,
        fontSize: '13px',
        color: '#1976D2',
        borderColor: '#1976D2',
        borderRadius: '4px',
        '&:hover': { backgroundColor: 'rgba(25, 118, 210, 0.04)', borderColor: '#1565C0' },
    },
    primary: {
        minWidth: 90,
        height: 40,
        borderRadius: '4px',
        bgcolor: '#1976D2',
        boxShadow: 'none',
        fontSize: '13px',
        fontWeight: 600,
        '&:hover': { bgcolor: '#1565C0', boxShadow: 'none' },
    },

    nextBtn: {
        textTransform: 'uppercase',
        fontWeight: 500,
        boxShadow: 'none',
        '&:hover': {
            boxShadow: 'none',
        },
    },
};

const ModalFooter = ({ activeStep, steps, onBack, onNext, onSubmit, onClose, isLoading, canNext = true, canSubmit = true }) => {
    return (
        <Box sx={styles.footer}>
            <Button onClick={onClose} color="error" variant="contained" backgroundColor="#fff" disabled={isLoading} sx={styles.cancelBtn}>
                CANCEL
            </Button>

            <Box sx={{ display: 'flex', gap: 2 }}>
                {activeStep > 0 && (
                    <Button onClick={onBack} variant="outlined" sx={styles.cancelBtn}>
                        BACK
                    </Button>
                )}

                {activeStep === steps.length - 1 ? (
                    <Button variant="contained" onClick={onSubmit} disabled={isLoading || !canSubmit} sx={styles.cancelBtn}>
                        {isLoading ? <CircularProgress size={20} sx={{ color: '#fff' }} /> : 'SEND'}
                    </Button>
                ) : (
                    <Button variant="contained" onClick={onNext} disabled={!canNext} sx={styles.nextBtn}>
                        NEXT
                    </Button>
                )}
            </Box>
        </Box>
    );
};

export default ModalFooter;
